import { createRouter, createWebHistory } from 'vue-router'
import { BasicLayout, ContainerLayout } from "@layouts"
import NProgress from 'nprogress'
import store from "@/store"
import { checkPermission } from "@utils/permission"
// import { message } from "ant-design-vue";
NProgress.configure({ showSpinner: false })

const loginRouteName = 'login'
const userRouteName = 'user'
const allowList = [loginRouteName, userRouteName]

const routes = [
    {
        name: 'root',
        path: '/',
        // component: BasicLayout,
        hidden: true,
        redirect: '/dashboard/workplace',
    },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import(/* webpackChunkName: "exception" */ '@/views/Login'),
    },
    {
        path: '/user',
        name: 'user',
        component: () =>
            import(/* webpackChunkName: "user" */ '@/views/User'),
    },
    {
        path: '/404',
        component: () =>
            import(/* webpackChunkName: "exception" */ '@/views/exception/404'),
    },
    {
        path: '/:pathMatch(.*)*',
        component: BasicLayout,
        name: 'nomatch',
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    // console.log('beforeEach')
    // console.log('to', to)
    // console.log('from', from)
    // console.log('next', next)
    // console.log('router.getRoutes()', router.getRoutes())
    // if (to.name == 'nomatch' || checkPermission(to?.meta, 'view')) {
    NProgress.start()
    if (!!store?.state?.user?.token != "" || allowList.includes(to.name) || checkPermission(to?.meta, "view")) {
        next()
    } else {//如果没有token 且 不是登录 且 没查看权限 转到登录
        next({ name: loginRouteName, query: { redirect: to.fullPath } })
        NProgress.done()
    }
    // } else {
    //   message.error('没有访问权限')
    //   return
    // }
})

router.afterEach((to, from, failure) => {
    // console.log('afterEach', to, from, failure, router.getRoutes())
    NProgress.done()
})

export default router

const constantRouterComponents = {
    ["BasicLayout"]: BasicLayout,
    ["ContainerLayout"]: ContainerLayout,
    ['Workplace']: () => import('@/views/dashboard/Workplace.vue'),
}

const addRoute = (route, parent, parentDescribe) => {
    if (!checkPermission(route, "view")) {
        return
    }
    const routeComponent = {
        path: `/${parent}/${route?.name}`,
        name: route?.name,
        component:
            constantRouterComponents[route?.component || route?.name] ||
            (() => import(`@/views/${route?.component}`)),
        meta: {
            title: route?.name,
            describe: route?.describe,
            icon: route?.icon,
            actions: route?.actions,
            parent: parentDescribe,
        },
    }
    if (parent) {
        router.addRoute(parent, routeComponent)
    } else {
        router.addRoute(routeComponent)
    }
    // console.log('addRoute', parent, route, routeComponent)

    if (route.children?.length > 0) {
        route.children.forEach((childRoute) => {
            addRoute(childRoute, route.name, route.describe)
        })
    }
}

const addRoutes = (routes) => {
    routes.map((route) => {
        addRoute(route)
    })
}

export { addRoutes }
